/** Per-page CTA band copy — headline, body, and button matched to page context. */
export const PAGE_CTAS = {
  about: {
    headlineBefore: 'Retention intelligence starts with',
    headlineAccent: 'better timing.',
    body: 'See how Stavyn helps leaders spot flight risk early and act with clarity — request a complimentary risk report for your team.',
    buttonLabel: 'Get Free Risk Report',
    buttonTo: '/schedule-demo',
  },
  blog: {
    headlineBefore: 'Turn insights into',
    headlineAccent: 'retention strategy.',
    body: 'Explore our thinking on talent and turnover — and request a complimentary retention risk report for your team.',
    buttonLabel: 'Get Free Risk Report',
    buttonTo: '/schedule-demo',
  },
  contact: {
    headlineBefore: 'Prefer to talk it through?',
    headlineAccent: 'Reach out anytime.',
    body: 'Our team responds within one business day. Ask about Stavyn, partnerships, or the free risk report pilot.',
    buttonLabel: 'Email Us',
    buttonTo: 'mailto:hello@stavyn.com',
  },
};
